import {Model, ModelMixin} from '../common/model.class';
import ProjectionInformation = Model.ProjectionInformation;

/**
 * Created by Rodrigo Quesada on 04/12/16.
 */
export class LicensesAndAffiliations extends ModelMixin() implements Model<LicensesAndAffiliations> {

    TYPE = LicensesAndAffiliations;
    static projectionInformation = new ProjectionInformation('licensesAndAffiliations');

    public medicalLicenseIssues: boolean;
    public otherLicenseIssues: boolean;
    public deaIssues: boolean;
    public academicAppointmentIssues: boolean;
    public hospitalStaffIssues: boolean;
    public clinicalPrivilegesIssues: boolean;
    public otherInstitutionalIssues: boolean;
    public professionalMembershipIssues: boolean;
    public professionalOfficeIssues: boolean;
    public governmentParticipationIssues: boolean;
    public otherProfessionIssues: boolean;
    public details: string;

    constructor(jsonData: any = {}) {
        super();
        Object.assign(this, jsonData);
    }

    askForDetails(): boolean {
        return this.medicalLicenseIssues
            || this.otherLicenseIssues
            || this.deaIssues
            || this.academicAppointmentIssues
            || this.hospitalStaffIssues
            || this.clinicalPrivilegesIssues
            || this.otherInstitutionalIssues
            || this.professionalMembershipIssues
            || this.professionalOfficeIssues
            || this.governmentParticipationIssues
            || this.otherProfessionIssues;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/liability/licenses-and-affiliations.model.ts